"use client";

import React, { useEffect, useState } from "react";
import { BannerProps } from "./Banner.types";
import CTA from "./variations/CTA";
import LTO from "./variations/LTO";

export const Banner: React.FC<BannerProps> = ({ variation, show_date, removal_date, location, ...rest }) => {
  const locationVariation = `${location || ""} Banner`.trim();
  const [enableBanner, setEnableBanner] = useState<boolean>(false);

  useEffect(() => {
    const currentDate = new Date();
    const afterShowDate = Boolean(show_date) && new Date(show_date as string).getTime() < currentDate.getTime();
    const beforeRemovalDate =
      Boolean(removal_date) && new Date(removal_date as string).getTime() > currentDate.getTime();

    const alwaysShow = show_date === undefined && removal_date === undefined;
    const showPastStartDate = afterShowDate && removal_date === undefined;
    const showBeforeRemovalDate = Boolean(show_date === undefined && beforeRemovalDate);
    const showInDateWindow = afterShowDate && beforeRemovalDate;

    setEnableBanner(alwaysShow || showPastStartDate || showBeforeRemovalDate || showInDateWindow);
  }, [show_date, removal_date]);

  if (!enableBanner) return null;

  switch (variation?.toLowerCase()) {
    case "lto":
      return <LTO location={locationVariation} {...rest} />;
    case "cta":
      return <CTA location={locationVariation} {...rest} />;
    default:
      return null;
  }
};
